import { Exclude, Expose, Transform } from "class-transformer";
export const ExcludeFrontend = () => (target, propertyKey) => {
    Exclude({ toPlainOnly: true })(target, propertyKey);
    Expose({ toClassOnly: true })(target, propertyKey);
};
export const ExposeFrontend = () => Expose();
export const Default = (fn) => Transform(({ value }) => value !== null && value !== void 0 ? value : fn());
//# sourceMappingURL=decorators.js.map